import html2canvas from "html2canvas";
import PptxGenJS from "pptxgenjs";
import { DashGridItem } from "../../DashGrid";

/**
 * Creates a PowerPoint slide for a given DashCard item
 * @param pptx The PptxGenJS instance
 * @param item The DashGridItem (dashboard card item)
 * @param chartRef The reference to the chart div
 * @param realChartData The actual data used in the chart (for tables)
 */
export const createPowerPointSlide = async (
    pptx: PptxGenJS, 
    item: DashGridItem, 
    chartRef?: HTMLDivElement | null, 
    realChartData?: any[]
) => {
    const slideTitle = item.title?.trim() ? item.title : item.subtitle;
    const slide = pptx.addSlide();
    const slideWidth = 10; // Default slide width in inches
    const slideHeight = 7.5; // Default slide height in inches

    // 🔹 Handle Table Export
    if (item.chartType === "table" && realChartData && realChartData.length > 0) {
        const columns = Object.keys(realChartData[0]);
        const tableRows = realChartData.map(row => columns.map(col => row[col] || ""));
        const maxRowsPerSlide = 10;
        let startRow = 0;
        let slideCount = 1;

        while (startRow < tableRows.length) {
            const tableSlide = slideCount > 1 ? pptx.addSlide() : slide;

            if (slideCount === 1) {
                tableSlide.addText(slideTitle, { 
                    x: 0.5, 
                    y: 0.3, 
                    fontSize: 24, 
                    bold: true, 
                    align: "center", 
                    w: slideWidth - 1, 
                    h: 0.5, 
                    paraSpaceAfter: 10,
                    valign: "top"
                });
            }

            tableSlide.addTable(
                [columns, ...tableRows.slice(startRow, startRow + maxRowsPerSlide)], 
                {
                    x: 0.5, 
                    y: slideCount === 1 ? 1.5 : 0.5, 
                    w: slideWidth - 1, 
                    colW: Array(columns.length).fill((slideWidth - 1) / columns.length), 
                    border: { type: "solid", color: "000000", pt: 1 },
                    fontSize: 12,
                    autoPage: true
                }
            );

            startRow += maxRowsPerSlide;
            slideCount++;
        }
    } else {
        // 🔹 Capture chart as image and scale it
        if (chartRef) {
            const canvas = await html2canvas(chartRef, { backgroundColor: "#fff" });
            const imgData = canvas.toDataURL("image/png");

            // Calculate aspect ratio and adjust size
            const imgAspectRatio = canvas.width / canvas.height;
            let imgWidth = slideWidth - 1; 
            let imgHeight = imgWidth / imgAspectRatio; 

            if (imgHeight > slideHeight - 1.5) {
                imgHeight = slideHeight - 1.5;
                imgWidth = imgHeight * imgAspectRatio;
            }

            slide.addText(slideTitle, { 
                x: 0.5, 
                y: 0.3, 
                fontSize: 24, 
                bold: true, 
                align: "center", 
                w: slideWidth - 1, 
                h: 0.5, 
                paraSpaceAfter: 10,
                valign: "top"
            });

            slide.addImage({ 
                data: imgData, 
                x: (slideWidth - imgWidth) / 2, 
                y: 1, 
                w: imgWidth, 
                h: imgHeight 
            });
        }
    }
};